module.exports = __webpack_public_path__ + "static/media/banner.25deafd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/modelo/banner.png
// module id = 188
// module chunks = 0